import { render, staticRenderFns } from "./AddMasiveProductsComponentView.vue?vue&type=template&id=04c5127c&scoped=true&"
import script from "./AddMasiveProductsComponentView.vue?vue&type=script&lang=js&"
export * from "./AddMasiveProductsComponentView.vue?vue&type=script&lang=js&"
import style0 from "./AddMasiveProductsComponentView.vue?vue&type=style&index=0&id=04c5127c&lang=scss&scoped=true&"
import style1 from "./AddMasiveProductsComponentView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5127c",
  null
  
)

export default component.exports